import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// @ts-ignore - side-effect css import handled by Vite at build; no vite-env.d.ts (kept minimal per recovery; tsc for typecheck only)
import './index.css'
import { Toaster } from 'sonner'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <Toaster position="top-center" richColors closeButton />
  </React.StrictMode>,
)
